/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMoon: {
  name: 'moon';
  data: string;
} = {
  name: 'moon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.854 1.146a.5.5 0 0 1 .112.535c-.995 2.568-.264 5.655 1.856 7.436 1.797 1.51 4.28 1.776 6.497.917a.5.5 0 0 1 .647.647C13.882 13.477 11.193 15.5 8 15.5A7.5 7.5 0 0 1 .5 8c0-3.193 2.023-5.882 4.82-6.966a.5.5 0 0 1 .534.112ZM4.698 2.444C2.789 3.574 1.5 5.632 1.5 8A6.5 6.5 0 0 0 8 14.5c2.363 0 4.417-1.284 5.549-3.186-2.21.509-4.568.084-6.37-1.431-2.155-1.81-3.058-4.754-2.481-7.44Z" fill="currentColor"/></svg>`,
};
